import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal-media-contain relative" };
import { UIModal, UIModalContent, UIModalHeader } from '@gohighlevel/ghl-ui';
import MediaCenter from './MediaCenter.vue';
import { inject } from 'vue';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'MediaModalView',
    props: {
        showModal: { type: Boolean },
        settings: {},
        fromSpmts: { type: Boolean }
    },
    emits: ["close"],
    setup(__props, { emit: __emit }) {
        const state = useStore();
        const emit = __emit;
        const parentEmitter = inject('emitter');
        const closeModal = () => {
            parentEmitter.emit('media-library-closed');
            emit('close');
            state.resetSelectedItems();
            state.activeCategory = 'my_media';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                id: `modal-media-library-outer`,
                width: 500,
                show: _ctx.showModal,
                className: "fixed top-10 left-0 right-0 flex justify-center media-modal-picker"
            }, {
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        class: "flex justify-end",
                        onClose: closeModal,
                        id: "modal-header"
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(MediaCenter, {
                                    settings: _ctx.settings,
                                    modal: true
                                }, null, 8 /* PROPS */, ["settings"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["show"]));
        };
    }
});
